export { default as BuyACarLottie } from "./BuyACar/BuyACarLottie";
export { default as EmailLottie } from "./Email/EmailLottie";
